import React from 'react';
import { styled } from '@mui/system';
import { TableCell, tableCellClasses } from '@mui/material';
import { NextButton } from '../../../share/themes';
import { DisabledButton } from '../../../share/components/disabledButton';

export const StyledTableCellAgreement = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'grey',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableCell = styled(TableCell)({
  '&.MuiTableCell-root': {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
  },
});

export const agreementNextButton = (disabled : boolean, agree: any) => (disabled ? (
  DisabledButton('Agree & Enter')
) : (
  <NextButton
    onClick={() => agree()}
  >
    Agree & Enter
  </NextButton>
));
